import { Component, Input, OnChanges, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { AlertSeverityLevel } from 'src/app/enums/alert.enum';

@Component({
  standalone: false,
  selector: 'app-severity-chip',
  templateUrl: './severity-chip.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./severity-chip.component.scss']
})
export class SeverityChipComponent implements OnChanges {
  @Input() severity: AlertSeverityLevel | number | null | undefined = AlertSeverityLevel.Watch;
  @Input() compact = false;

  label = '';
  title = '';
  chipClass = 'severity-watch';

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.severity || changes.compact) {
      const severity = this.severity;

      if (severity === AlertSeverityLevel.Critical) {
        this.label = 'Critical';
        this.chipClass = 'severity-critical';
      } else if (severity === AlertSeverityLevel.Alert) {
        this.label = 'Alert';
        this.chipClass = 'severity-alert';
      } else if (severity === AlertSeverityLevel.Action) {
        this.label = 'Action';
        this.chipClass = 'severity-action';
      } else if (severity === AlertSeverityLevel.Watch) {
        this.label = 'Watch';
        this.chipClass = 'severity-watch';
      } else {
        this.label = 'Unknown';
        this.chipClass = 'severity-unknown';
      }

      this.title = this.label;
    }
  }
}
